import { render, staticRenderFns } from "./PxEjemploFormulario.vue?vue&type=template&id=3abaeaec&scoped=true&"
import script from "./PxEjemploFormulario.vue?vue&type=script&lang=js&"
export * from "./PxEjemploFormulario.vue?vue&type=script&lang=js&"
import style0 from "./PxEjemploFormulario.vue?vue&type=style&index=0&id=3abaeaec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abaeaec",
  null
  
)

export default component.exports